export const environment = {
  domain: 'codingwithkids.com',
  domainName: 'Coding with Kids',
  imagesServer: 'd3t4xfu733v2tb.cloudfront.net',
  localStoragePrefix: 'CWK.',
  name: null,
  production: true,
  project: 'cwk',
  shortName: 'prod',
  googleMapsApiKey: 'AIzaSyALHP-WVMU0s0oHehiEbUmrtAj6R60BbTI',
  stripeKey: 'pk_live_JIyVbmvfX83ZLroT4mIsZMoy',
  urlAppAdminPrefix: 'admin',
  urlAppAmazonScholarshipPrefix: 'amazon',
  urlAppCheckoutPrefix: 'checkout',
  urlAppCurriculumPrefix: 'curriculum',
  urlAppHomePrefix: '',
  urlAppLandingPagesPrefix: 'welcome',
  urlAppTrainingPrefix: 'training',
  urlConfirmationPath: 'confirmations',
  urlRoot: 'https://www.codingwithkids.com',
  urlSignOut: 'https://www.codingwithkids.com',
  urlStudentProfilePath: 'profile',
  urlWebServices: 'https://www.codingwithkids.com/be/index.php'
};
